import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Horas buscando rutinas en YouTube sin saber si son para vos',
  good: '10 minutos mirando tu plan de la semana'
}, {
  bad: 'Empezar y abandonar cada 2 o 3 semanas',
  good: 'Sistema anti-abandono integrado desde el día 1'
}, {
  bad: 'Sin saber cómo progresar hacia las estaciones HYROX',
  good: 'Progresión clara semana a semana hacia tu primera carrera'
}, {
  bad: 'Comer sin criterio y sin energía para entrenar',
  good: 'Guía de alimentación práctica para rendir y recuperarte'
}, {
  bad: 'Semanas caóticas donde el entrenamiento no entra',
  good: 'La Semana Perfecta organiza todo en 10 minutos'
}, {
  bad: 'Sin métricas ni registro de avance',
  good: 'Planillas de seguimiento listas para usar'
}, {
  bad: 'Llegar al gym sin saber qué hacer hoy',
  good: 'Plan diario claro con versión casa y versión gym'
}, {
  bad: 'Sin fecha ni objetivo concreto',
  good: 'Tu primera carrera HYROX como meta real y medible'
}];
export function Comparison() {
  return <section className="py-24 px-4 bg-brand-cream text-brand-black" data-id="element-38">
      <div className="max-w-5xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-40">
          <div className="text-brand-copper font-bold tracking-widest uppercase text-sm mb-4" data-id="element-41">
            LA REALIDAD
          </div>
          <h2 className="text-4xl md:text-6xl font-display mb-4" data-id="element-42">
            ¿Cuánto cuesta <span className="text-brand-pink" data-id="element-43">NO tenerlo?</span>
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-200" data-id="element-44">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-45">
            <div className="p-6 text-center font-bold text-gray-500 uppercase tracking-wider text-sm md:text-base" data-id="element-46">
              Sin el sistema
            </div>
            <div className="p-6 text-center font-bold text-brand-pink uppercase tracking-wider text-sm md:text-base bg-brand-pink/5" data-id="element-47">
              Con el sistema
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-48">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-49">
                <div className="p-4 md:p-6 flex items-start gap-3 text-sm md:text-base text-gray-600" data-id="element-50">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-51" />
                  <span data-id="element-52">{row.bad}</span>
                </div>
                <div className="p-4 md:p-6 flex items-start gap-3 text-sm md:text-base font-medium text-brand-black bg-brand-pink/5" data-id="element-53">
                  <CheckIcon className="w-5 h-5 text-brand-pink flex-shrink-0 mt-0.5" data-id="element-54" />
                  <span data-id="element-55">{row.good}</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}